import type { Routes } from '@angular/router';
import {
    BusinessCustomerFeature,
    createActionTriggerDealer,
    createMetaResolverWithDealer,
    defaultTitleResolver,
    ngrxLoaderGuard,
    PageContentType,
} from '@hyundai/ng-common-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { BusinessCustomerPageComponent } from './business-customer-page.component';

export default [
    {
        path: '',
        component: BusinessCustomerPageComponent,
        canActivate: [
            ngrxLoaderGuard({
                waitUntilLoadedSelector: BusinessCustomerFeature.state.selectIsLoadingBusinessCustomer,
                dataToCheckSelector: BusinessCustomerFeature.state.selectContent,
            }),
        ],
        providers: [
            provideState(BusinessCustomerFeature.state),
            provideEffects([BusinessCustomerFeature.effects]),
            createActionTriggerDealer(BusinessCustomerFeature.actions.loadPageBusinessCustomer()),
        ],
        title: defaultTitleResolver('Gewerbekunden'),
        resolve: {
            meta: createMetaResolverWithDealer(async (dealer) => {
                return {
                    description: `Entdecken Sie attraktive Leasingangebote und Vorteile für Ihr Business bei ${dealer.name} ${dealer.city}.`,
                };
            }),
        },
        data: {
            contentType: PageContentType.BUSINESSCUSTOMER,
        },
    },
] satisfies Routes;
